import Vue from 'vue';

export default {
    namespaced: true,

    actions: {
        async fetchFormCodes() {
            const { data } = await Vue.axios.get('/forms/codes');
            return data;
        },

        async fetchList(ctx, params = {}) {
            const { data } = await Vue.axios.get('/forms', { params });
            return data;
        },

        async updateStatus(ctx, { id, status }) {
            const { data } = await Vue.axios.patch(`/forms/${id}/status`, { status });
            return data;
        },
    },
};
